export const COMMENT = '@@comments/COMMENT';



// WEBPACK FOOTER //
// ./src/app/Comments/actionTypes.js